import React from "react";

// Wordmark PROGÈRE : PRO or (noir en mode clair), GÈRE rouge.
// Utilise des classes (.pg-pro/.pg-gere) pour être theme-aware via CSS.
export function ProgereText({ className = "", pro, gere }) {
  return (
    <span className={className}>
      <span className="pg-pro" style={pro ? { color: pro } : undefined}>PRO</span>
      <span className="pg-gere" style={gere ? { color: gere } : undefined}>GÈRE</span>
    </span>
  );
}

// Titre de module : "PROGÈRE" (PRO or + GÈRE rouge) + suffixe (ex. CRM) en blanc/noir.
// Calligraphie identique au mot-symbole officiel ProgereText/ProgereBrand.
export function ModuleTitle({ name = "", className = "" }) {
  const suffix = name.replace(/^PROG[ÈE]RE\s*/i, "");
  return (
    <span className={`font-black tracking-tight ${className}`}>
      <span className="pg-pro">PRO</span>
      <span className="pg-gere">GÈRE</span>
      {suffix ? <span className="text-white">{` ${suffix}`}</span> : null}
    </span>
  );
}
